export const TipDoc = [
    { key: '1', value: '1', text: 'FACTURA' },
    { key: '2', value: '2', text: 'GUÍA' },
];
export const TipDocOut = [
    { key: '1', value: '1', text: 'FACTURA' },
    { key: '2', value: '2', text: 'GUÍA' },
];

export const TipoIn= [
    { key: '1', value: '1', text: 'COMPRA' },
    { key: '2', value: '2', text: 'ARRIENDO' },
    { key: '3', value: '3', text: 'COMODATO' },
];
export const TipoOut= [
    { key: '1', value: '1', text: 'PACIENTE' },
    { key: '2', value: '2', text: 'SERVICIO TECNICO' },  
    { key: '3', value: '3', text: 'RETIRO PACIENTE' },
    { key: '4', value: '4', text: 'RETIRO SERVICIO TECNICO' },
    { key: '5' ,value: '5', text: 'DEVOLUCION A PROVEEDOR' }
];

export const Programas= [
    { key: '1', value: 'ANUAL', text: 'ANUAL', dias: '365' },
    { key: '2', value: 'SEMESTRAL', text: 'SEMESTRAL', dias: '180' },
    { key: '3', value: 'TRIMESTRAL', text: 'TRIMESTRAL', dias: '90' },
];

export const Categoria= [
    { key: '1', value: '1', text: 'CHECK' },
    { key: '2', value: '2', text: 'INSTRUMENTOS' },
    { key: '3', value: '3', text: 'MEDICION' },
    { key: '4', value: '4', text: 'SEGURIDAD' },
];

export const Opcion= [
    { key: '1', value: '1', text: 'TIPO 2 / B' },
    { key: '2', value: '2', text: 'TIPO 2 / BF' },
    { key: '3', value: '3', text: 'CLASE I' },
    { key: '4', value: '4', text: 'CLASE II A' },
    { key: '5', value: '5', text: 'CLASE II B' },
    { key: '6', value: '6', text: 'CLASE III ' },
];

export const Medidas= [
    { key: '1', value: '1', text: 'CM H2O' },
    { key: '2', value: '2', text: 'LPM' },
    { key: '3', value: '3', text: 'BAR' },
    { key: '4', value: '4', text: 'MICROAMPERE' },
    { key: '5', value: '5', text: 'GIGA OHM' },
    { key: '6', value: '6', text: 'GRADOS CELSIUS' },
    { key: '7', value: '7', text: 'O2' },
    { key: '8', value: '8', text: 'MILILITROS' },
    { key: '9', value: '9', text: 'PSI' },
];

export const Servicio= [
    { key: '1', value: '1', text: 'MANTENCION PREVENTIVA' },
    { key: '2', value: '2', text: 'PRESUPUESTO' },
    { key: '3', value: '3', text: 'EVALUACION POR GARANTIA' },
];

export const ItemST= [
    { key: '1', text: 'TEST INGRESO', value: 'TEST INGRESO' },
    { key: '2', text: 'REPUESTO', value: 'REPUESTO' },
    { key: '3', text: 'SERVICIO', value: 'SERVICIO' },
    { key: '4', text: 'FALLA', value: 'FALLA' },
    { key: '5', text: 'TEST GARANTIA', value: 'TEST GARANTIA' },
    { key: '6', text: 'IRREPARABLE', value: 'IRREPARABLE' }
];